var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from './translate';
import { deconstructActions } from './actions';
import { deconstructBlueprintReference } from './blueprintReferences';
import { constructFromActionDefinition } from './definitions/action';
import { constructFromBlueprintDefinition } from './definitions/blueprint';
import { constructFromFlowDefinition } from './definitions/flow';
import { DominoBuilderError, DominoBuilderErrorScope, DominoBuilderErrorSeverity, DominoBuilderErrorType, filterErrors, getErrorAggregateCallback, } from './errors';
import { getIsActionDefinition, getIsBlueprintDefinition, getIsFlowDefinition, validateDefinition, } from './helpers';
import { deconstructParameters } from './parameters';
import { deconstructTriggerCall } from './triggers';
import { DefinitionType } from './types';
export const constructFromDefinition = (dominoDefinitionRoot, blueprintRegistryClient, resourceRegistry, symbolTable) => __awaiter(void 0, void 0, void 0, function* () {
    let state;
    let errors = [];
    const errorAggregateCallbacks = [];
    if (getIsFlowDefinition(dominoDefinitionRoot)) {
        state = yield constructFromFlowDefinition(dominoDefinitionRoot, blueprintRegistryClient, resourceRegistry, symbolTable, validateDefinition(dominoDefinitionRoot.flow));
    }
    else if (getIsBlueprintDefinition(dominoDefinitionRoot)) {
        state = yield constructFromBlueprintDefinition(dominoDefinitionRoot, resourceRegistry, symbolTable, validateDefinition(dominoDefinitionRoot.blueprint));
    }
    else if (getIsActionDefinition(dominoDefinitionRoot)) {
        state = yield constructFromActionDefinition(dominoDefinitionRoot, resourceRegistry, symbolTable, validateDefinition(dominoDefinitionRoot.action));
    }
    else {
        errors.push(new DominoBuilderError(DominoBuilderErrorType.ParseError, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.FATAL, t('errors.parse_failed'), {
            path: `Flow`,
        }));
        return Object.assign(Object.assign({}, state), { errors, getErrorAggregate: (scope, severity) => filterErrors(scope, severity, errors) });
    }
    state = Object.assign(Object.assign({}, state), { getErrorAggregate: (scope, severity) => {
            var _a;
            return filterErrors(scope, severity, errors).concat((_a = errorAggregateCallbacks === null || errorAggregateCallbacks === void 0 ? void 0 : errorAggregateCallbacks.reduce((a, c) => { var _a; return a.concat((_a = c === null || c === void 0 ? void 0 : c(scope, severity)) !== null && _a !== void 0 ? _a : []); }, [])) !== null && _a !== void 0 ? _a : []);
        } });
    errorAggregateCallbacks.push(getErrorAggregateCallback(state, 'blueprintReference'));
    errorAggregateCallbacks.push(getErrorAggregateCallback(state, 'parameters'));
    errorAggregateCallbacks.push(getErrorAggregateCallback(state, 'trigger'));
    errorAggregateCallbacks.push(getErrorAggregateCallback(state, 'actions'));
    return state;
});
export const deconstructOutput = (output) => {
    var _a;
    const metadata = (({ name, description, tags }) => ({ name, description, tags }))(output);
    // strip optional undefined metadata
    if (!!!metadata.description) {
        delete metadata.description;
    }
    if (!!!metadata.tags) {
        delete metadata.tags;
    }
    let definition = Object.assign(Object.assign({}, metadata), { spec: undefined });
    const isFlowOrBlueprint = output.type === DefinitionType.Flow || output.type === DefinitionType.Blueprint;
    const isParameterizable = output.type === DefinitionType.Action || output.type === DefinitionType.Blueprint;
    if (isFlowOrBlueprint && output.isDerived) {
        //blueprint
        definition = Object.assign(Object.assign({}, definition), { spec: deconstructBlueprintReference(output.blueprintReference) });
    }
    else if (isFlowOrBlueprint) {
        //flow
        definition = Object.assign(Object.assign({}, definition), { spec: {
                trigger: deconstructTriggerCall(output.trigger),
                actions: (_a = deconstructActions(output.actions)) !== null && _a !== void 0 ? _a : [],
            } });
    }
    else {
        //future: flesh out definitions where spec is present vs. optional.
        definition = Object.assign(Object.assign({}, definition), { spec: {} });
    }
    if (isParameterizable && output.parameters) {
        definition = Object.assign(Object.assign({}, definition), { params: deconstructParameters(output.parameters) });
    }
    let root;
    if (output.type === DefinitionType.Action) {
        root = { action: definition };
    }
    else if (output.type === DefinitionType.Blueprint) {
        root = { blueprint: definition };
    }
    else {
        root = { flow: definition };
    }
    return root;
};
//# sourceMappingURL=definitions.js.map